import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchTreatments} from '../../../actions/addTreatments';
import { getCurrentPetShop } from "../../../actions/petShop";
import ViewTreatment from '../../treatments/treatments/viewTreatment';
import { NavLink } from 'react-router-dom';
import { fetchMedicalRecords } from '../../../actions/medicalRecords';
import moment from 'moment';
import _ from 'lodash';
const $ = window.$;
const intialState = {
    trmntsOnGoing:[],
    trmntsPending:[],
    mRecords1:[],
    mRecords2:[],
    treatId:''
}

class CaretakerDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = intialState;
      }
    viewTreatment(tId) {
        this.setState({treatId: tId})
        $('#view_treatment').modal('show');
    }
    componentDidMount() {
        this.props.fetchTreatments();
        this.props.fetchMedicalRecords();
    }
    componentWillReceiveProps = (nextProps) => {
        // if(nextProps.treatmentError||nextProps.mRecordsError){
        //     NotificationManager.error('Something went wrong!')
        // }
        
        if ( this.props.treatments !== nextProps.treatments) {
            let trtPending = nextProps.treatments.filter(m => m.status==='Pending').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            let trtInprogress = nextProps.treatments.filter(m => m.status==='In progress').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            this.setState({ trmntsPending: trtPending, trmntsOnGoing: trtInprogress });
        }
        if(nextProps.mRecords && nextProps.mRecords.medicalRecords && nextProps.mRecords.medicalRecords.length > 0 && this.props.mRecords.medicalRecords !== nextProps.mRecords.medicalRecords){
            let allMRecords = nextProps.mRecords.medicalRecords;
            let mRecords1 = allMRecords.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(0,5);
            let mRecords2 = allMRecords.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(5,10);
            this.setState({ mRecords1: mRecords1, mRecords2: mRecords2,  allmRecords: allMRecords }); 
        }
    }
    navigationMr(y){    
        let data = this.state.allmRecords;    
        let index = _.findIndex(data, {id: y.id});    
        let previndex = (index == 0) ? null : (index - 1);
        let nextindex = index + 1;    
        let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id : null : null;
        let nextEle = previndex != null ? data[previndex] ? data[previndex].id : -1 : -1; 
        let path = `/medical-records/${y.id}/${prevEle}/${nextEle}`;
        this.props.history.push(path);    
      
        }
    render() {
        const {trmntsOnGoing, trmntsPending, treatId, mRecords1, mRecords2} = this.state;
        const { petShop } = this.props;
        
        return (
        <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                    <div className="m-grid__item m-grid__item--fluid m-wrapper">
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="m-portlet m-portlet--head-overlay m-portlet--full-height   m-portlet--rounded-force">
                                    <div className="m-portlet__head m-portlet__head--fit">
                                        <div className="m-portlet__head-caption">
                                            <div className="m-portlet__head-title">
                                                <h3 className="m-portlet__head-text m--font-light">
                                                    Treatments
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m-portlet__body">
                                        <div className="m-widget28">
                                            {  petShop.caretaker_dashboard_banner_path ?
                                                <div className="m-widget28__pic m-portlet-fit--sides">
                                                    <img src={
                                                      petShop.dashboard_banner_path
                                                      ? process.env.REACT_APP_S3_PATH +
                                                      "/" + petShop.caretaker_dashboard_banner_path: ""
                                                    } alt=""/>                                                              
                                                </div>:                                                  
                                                <div className="m-widget28__pic m-portlet-fit--sides"><img src="assets/app/media/img/pets/pupBg.jpg" alt=""/>
                                                </div>
                                            }
                                            {/* <div className="m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides" style={{backgroundImage: `url(${process.env.REACT_APP_S3_PATH}/${petShop.dashboard_banner_path})`, backgroundSize: 'cover' }}> */}
                                            <div className="m-widget28__container">
                                                <ul className="m-widget28__nav-items nav nav-pills nav-fill" role="tablist">
                                                    <li className="m-widget28__nav-item nav-item">
                                                        <a className="nav-link active show" data-toggle="pill" href="#menu11">
                                                            <span>
                                                                <i className="fas fa-syringe" style={{paddingBottom:'2rem',paddingTop:'1.4rem'}}></i>
                                                            </span>
                                                            <span>On going Treatments</span>
                                                        </a>
                                                    </li>
                                                    {/* <li className="m-widget28__nav-item nav-item">
                                                        <a className="nav-link" data-toggle="pill" href="#menu21">
                                                            <span>
                                                                <i className="fa flaticon-file-1"></i>
                                                            </span>
                                                            <span>IMT Invoice</span>
                                                        </a>
                                                    </li> */}
                                                    <li className="m-widget28__nav-item nav-item">
                                                        <a className="nav-link" data-toggle="pill" href="#menu31">
                                                            <span>
                                                                <i className="fas fa-syringe" style={{paddingBottom:'2rem',paddingTop:'1.4rem'}}></i>
                                                            </span>
                                                            <span>Pending Treatments</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div className="m-widget28__tab tab-content">
                                                    <div id="menu11" className="m-widget28__tab-container tab-pane active show">
                                                        <div className="m-widget28__tab-items" >
                                                            <ul className="list-unstyled mb-0 list-widget">
                                                            {trmntsOnGoing.length> 0? trmntsOnGoing.map((t,i)=>(
                                                                <a href="#" onClick={(e)=>{e.preventDefault()}}>
                                                                <li key={i} onClick={()=>this.viewTreatment(t.id)}>
                                                                    <div className="m-widget28__tab-item" >
                                                                        <div className="media mb-4">
                                                                            <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                            <div className="media-body list-widget-border">
                                                                                <div className="float-left">
                                                                                    <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>
                
                                                                                    <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>                                                                         
                                                                                    <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                </div>
                                                                                <div className='float-right'>
                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                <p className="text-muted">{t.daysLeft?t.daysLeft:0}<small> days remaining</small></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <hr/>
                                                                </a>
                                                            )):<span>No any ongoing treatments.</span>}
                                                            
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    {/* <div id="menu21" className="m-widget28__tab-container tab-pane fade">
                                                        <div className="m-widget28__tab-items">
                                                            <div className="m-widget28__tab-item">
                                                                <span>Project Description</span>
                                                                <span>Back-End Web Architecture</span>
                                                            </div>
                                                            <div className="m-widget28__tab-item">
                                                                <span>Total Charges</span>
                                                                <span>USD 2,170.000</span>
                                                            </div>
                                                            <div className="m-widget28__tab-item">
                                                                <span>INE Number</span>
                                                                <span>D110-1234562546</span>
                                                            </div>
                                                            <div className="m-widget28__tab-item">
                                                                <span>Company Name</span>
                                                                <span>SLT Back-end Solutions</span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div id="menu31" className="m-widget28__tab-container tab-pane fade">
                                                    <div className="m-widget28__tab-items">
                                                            <ul className="list-unstyled mb-0 list-widget">
                                                            {trmntsPending.length>0?trmntsPending.map((t,i)=>(
                                                                <a href="#" onClick={(e)=>{e.preventDefault()}}>
                                                                <li key={i} onClick={()=>this.viewTreatment(t.id)}>
                                                                    <div className="m-widget28__tab-item" >
                                                                        <div className="media mb-4">
                                                                            <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                            <div className="media-body list-widget-border">
                                                                                <div className="float-left">
                                                                                    <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>
                
                                                                                    <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>                                                                         
                                                                                    <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                </div>
                                                                                <div className='float-right'>
                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                <p className="text-muted">{t.daysLeft?t.daysLeft:0}<small> days remaining</small></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                </a>
                                                            )):<span>No any pending treatments.</span>}
                                                            <hr/>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                </div>
                            <div className="col-xl-8">
                                <div className="m-portlet m-portlet--full-height ">
                                        <div className="m-portlet__head">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                        Recent Puppy Records
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="m-portlet__body">
                                        <div className="m-widget3">          
                                            <div className="row">
                                                <div className="col-xl-6">
                                                    {mRecords1.map((m,i)=>(                                  
                                                        <div className="m-widget3__item"  >
                                                            <div className="m-widget3__header">
                                                                <div className="m-widget3__user-img">
                                                                    <img className="m-widget3__img" src={process.env.REACT_APP_S3_PATH + '/' + m.avatar_path + '/' + m.avatar_file_name} alt=""/>
                                                                </div>
                                                                <div className="m-widget3__info pb-2">
                                                                    {/* <span className="m-widget3__username">
                                                                        Melania Trump
                                                                    </span> */}
                                                                     <a style={{cursor: "pointer"}} onClick={e=>{this.navigationMr(m)}}>
                                                                    <span className="m-badge m-badge--info px-2"> Pet Id:<strong>{m.pet_id}</strong></span>
                                                                     </a>
                                                                    <br/>
                                                                    <p className="m-widget3__text mb-0">
                                                                        <strong>Breed:</strong> {m.Breed.breed_type}
                                                                    </p>
                                                                    <span className="m-widget3__time">
                                                                        {moment().diff( m.createdAt, 'days')} days ago.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>                                                 
                                                    ))}
                                                </div>
                                                <div className="col-xl-6">
                                                        {mRecords2.map((m, i) => (                                                          
                                                            <div className="m-widget3__item"  >
                                                                 <div className="m-widget3__header">
                                                                     <div className="m-widget3__user-img">
                                                                         <img className="m-widget3__img" src={process.env.REACT_APP_S3_PATH + '/' + m.avatar_path + '/' + m.avatar_file_name} alt=""/>
                                                                     </div>
                                                                     <div className="m-widget3__info pb-2">
                                                                         {/* <span className="m-widget3__username">
                                                                             Melania Trump
                                                                         </span> */}
                                                                          <a style={{cursor: "pointer"}} onClick={e=>{this.navigationMr(m)}}>
                                                                         <span className="m-badge m-badge--info px-2"> Pet Id:<strong>{m.pet_id}</strong></span>
                                                                         </a>
                                                                         <br/>
                                                                         <p className="m-widget3__text mb-0">
                                                                             <strong>Breed:</strong> {m.Breed.breed_type}
                                                                         </p>
                                                                         <span className="m-widget3__time">
                                                                             {moment().diff( m.createdAt, 'days')} days ago.
                                                                         </span>
                                                                     </div>
                                                                 </div>    
                                                             </div>                                  
                                                        ))}
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ViewTreatment treatmentId={treatId} />
                </div>
            </div>

        )
    }

}

const mapStateToProps = state => ({
  user: state.cognito.user,
  treatments:state.addFormulaReducer.treatment,
  mRecords:state.medicalRecordsReducer.mRecords,

  mRecordsError:state.medicalRecordsReducer.mRecordsError,
  treatmentError:state.addFormulaReducer.treatmentError,

  petShop: state.petShopReducer.currentPetshop,  
  
});
const mapDispatchToProps = dispatch => ({
    fetchTreatments: () => {
        dispatch(fetchTreatments());
    },
    fetchMedicalRecords: () => {
        dispatch(fetchMedicalRecords());
    },
    getCurrentPetShop: t => {
        dispatch(getCurrentPetShop(t));
    }
    
    
});


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CaretakerDashboard));
